export function Hero() {
  return `
    <section class="hero text-center text-white">
      <div class="container">

        <h1 data-aos="fade-up" class="mb-3">
          Solusi Digital untuk <span class="text-danger">Bisnis Anda</span>
        </h1>

        <p data-aos="fade-up" data-aos-delay="100" class="mb-4">
          Dari percetakan hingga pembuatan website, semua kebutuhan digital Anda dalam satu tempat
        </p>

        <div data-aos="fade-up" data-aos-delay="200" class="d-flex justify-content-center flex-wrap gap-3">
          <a href="https://wa.me/6283872687465" target="_blank" class="btn btn-danger px-4">
            Konsultasi WhatsApp
          </a>

          <a href="#layanan" class="btn btn-outline-light px-4">
            Lihat Layanan
          </a>
        </div>

      </div>
    </section>
  `;
}
